module.exports = __webpack_public_path__ + "img/metaforika.acb99bf4.png";